
import React from "react";
import { Card } from "@/components/ui/card";
import { Users, Shield, User } from "lucide-react";
import { UserCounts } from "../types/userTypes";

interface UserStatsCardsProps {
  userCounts: UserCounts;
  isLoading: boolean;
}

const UserStatsCards: React.FC<UserStatsCardsProps> = ({ userCounts, isLoading }) => {
  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      <Card className="flex items-center justify-between p-4">
        <div className="space-y-1">
          <p className="text-sm text-muted-foreground">Total Users</p>
          <p className="text-2xl font-bold">
            {isLoading ? (
              <span className="animate-pulse">...</span>
            ) : (
              (userCounts.admin || 0) + (userCounts.user || 0)
            )}
          </p>
        </div>
        <Users className="h-8 w-8 text-muted-foreground" />
      </Card>
      
      <Card className="flex items-center justify-between p-4">
        <div className="space-y-1">
          <p className="text-sm text-muted-foreground">Admin Users</p>
          <p className="text-2xl font-bold">
            {isLoading ? (
              <span className="animate-pulse">...</span>
            ) : (
              userCounts.admin || 0
            )}
          </p>
        </div>
        <Shield className="h-8 w-8 text-muted-foreground" />
      </Card>
      
      <Card className="flex items-center justify-between p-4">
        <div className="space-y-1">
          <p className="text-sm text-muted-foreground">Regular Users</p>
          <p className="text-2xl font-bold">
            {isLoading ? (
              <span className="animate-pulse">...</span>
            ) : (
              userCounts.user || 0
            )}
          </p>
        </div>
        <User className="h-8 w-8 text-muted-foreground" />
      </Card>
    </div>
  );
};

export default UserStatsCards;
